import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { RadioGroupStateService } from "./radio-group-state.service";

@Component({
    selector: "common-radio-group",
    templateUrl: "./common-radio-group.component.html",
    providers: [
        CommonFieldManagerDirective,
        { provide: FieldStateService, useClass: RadioGroupStateService },
        { provide: FIELD_TOKEN, useValue: "commonFormRadioGroups" },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonRadioGroupComponent {
    @Input() @BooleanAttribute() public addNoneOption = false;
    @HostBinding("class.u-display-flex") public isFlex = true;
    public noneIsSelected = false;

    constructor(public fieldManager: CommonFieldManagerDirective) { }

    public selectNone(actions) {
        actions.clearState();
        this.noneIsSelected = true;
    }

    public onChange(actions, option, i) {
        actions.onModelChange(option, i);
        this.noneIsSelected = false;
    }
}
